// Mock data for AAA Irrigation Service landing pages

// Local photos served from public folder — each used in exactly one location
const IMAGES = {
  logo: "/header_new.webp",
};

export const COMPANY_INFO = {
  name: "AAA IRRIGATION SERVICE, LLC",
  phone: "469-751-3567",
  phoneFormatted: "(469) 751-3567",
  license: "LI0016993",
  licenseUrl: "https://www2.tceq.texas.gov/lic_dpa/index.cfm?fuseaction=licall.showdetail&rid=305322112005269",
  email: "info@aaairrigationservice.com",
  tagline: "Integrity By The Drop Since 2005",
  bookingUrl: "/schedule",
  hours: {
    weekday: "Mon-Fri: 7:00 AM - 6:00 PM",
    saturday: "Sat: 8:00 AM - 4:00 PM",
    sunday: "Sun: Emergency Only"
  }
};

export const SERVICE_AREAS = [
  "Plano",
  "Allen",
  "Frisco",
  "McKinney",
  "Richardson",
  "Murphy",
  "Wylie",
  "Lucas",
  "Fairview"
];

export const SERVICES = [
  {
    id: "sprinkler-repair",
    title: "Sprinkler Repair",
    shortDescription: "Complete sprinkler system diagnostics and repair services for residential and commercial properties.",
    heroImage: "/irrigation-rotors.webp",
    h1: "Professional Sprinkler Repair in Plano & Allen, TX",
    intro: "Is your sprinkler system not performing as it should? AAA Irrigation Service provides expert sprinkler repair services throughout North Texas. Our TCEQ licensed technicians (LI0016993) diagnose and fix all sprinkler issues quickly, ensuring your lawn stays healthy and green.",
    services: [
      "Complete system diagnostics and troubleshooting",
      "Sprinkler head replacement and adjustment",
      "Pipe repair and replacement",
      "Valve repair and replacement",
      "Controller programming and repair",
      "Water pressure optimization",
      "System winterization and spring startup"
    ],
    signs: [
      "Uneven water distribution across your lawn",
      "Brown or dead patches despite regular watering",
      "Unusually high water bills",
      "Sprinkler heads not popping up or retracting",
      "Water pooling in certain areas",
      "Sputtering or misting spray heads"
    ],
    faqs: [
      {
        question: "How much does sprinkler repair cost in Allen, TX?",
        answer: "Sprinkler repair costs vary based on the issue. Simple head replacements start around $75-150, while more complex repairs like valve replacements or pipe repairs range from $150-400. We provide free estimates before any work begins."
      },
      {
        question: "How quickly can you respond to repair requests?",
        answer: "Book online for any weekday starting tomorrow, and we\'ll call or text to confirm your appointment within 24 hours. For emergencies, we offer after-hours service to prevent water damage or waste."
      },
      {
        question: "Do you warranty your sprinkler repairs?",
        answer: "Yes, all our repairs come with a full 1-year warranty on both parts and labor. We stand behind our work."
      },
      {
        question: "Can you repair any brand of sprinkler system?",
        answer: "Absolutely. Our technicians are trained to work on all major brands including Rain Bird, Hunter, Toro, Irritrol, and Weathermatic."
      }
    ],
    relatedServices: ["sprinkler-leak-repair", "valve-repair", "sprinkler-head-repair"]
  },
  {
    id: "sprinkler-leak-repair",
    title: "Sprinkler Leak Repair",
    shortDescription: "Expert leak detection and repair to stop water waste and prevent landscape damage.",
    heroImage: "/pipe-repair.webp",
    h1: "Sprinkler Leak Repair Services in Allen & Plano, TX",
    intro: "Sprinkler leaks waste water, increase your bills, and can cause serious damage to your landscape and foundation. AAA Irrigation Service specializes in fast, accurate leak detection and repair throughout Collin County.",
    services: [
      "Underground leak detection and location",
      "Main line leak repair",
      "Lateral line repairs",
      "Fitting and connection repairs",
      "Sprinkler head seal replacement",
      "Valve leak repair",
      "Pressure testing and diagnostics"
    ],
    signs: [
      "Unexplained spike in water bills",
      "Soggy or muddy spots in your yard",
      "Water bubbling up from the ground",
      "Low water pressure in sprinkler zones",
      "Green patches where grass shouldn't be thriving",
      "Constant sound of running water when system is off"
    ],
    faqs: [
      {
        question: "How do you find underground sprinkler leaks?",
        answer: "We use a combination of visual inspection, pressure testing, and zone isolation to pinpoint leak locations. Our experienced technicians can often locate leaks without extensive digging."
      },
      {
        question: "How much water can a sprinkler leak waste?",
        answer: "Even a small leak can waste thousands of gallons per month. A 1/32-inch crack in a pipe under 60 PSI can waste over 6,000 gallons monthly, significantly impacting your water bill."
      },
      {
        question: "Will leak repair damage my landscaping?",
        answer: "We minimize disruption by precisely locating leaks before digging. We repair the smallest area necessary and restore the landscape after repairs."
      },
      {
        question: "Can leaks cause foundation damage?",
        answer: "Yes, persistent leaks near your foundation can cause soil erosion and foundation movement. Quick repair is essential to prevent costly structural damage."
      }
    ],
    relatedServices: ["sprinkler-repair", "valve-repair", "pressure-testing"]
  },
  {
    id: "pressure-testing",
    title: "Pressure Testing & Inspection",
    shortDescription: "Professional irrigation system pressure testing and comprehensive inspections to identify issues before they become costly problems.",
    heroImage: "/pressure-testing.webp",
    h1: "Irrigation Pressure Testing & System Inspection in North Texas",
    intro: "Proper water pressure is essential for efficient irrigation. AAA Irrigation Service provides professional pressure testing and comprehensive system inspections to ensure your sprinkler system operates at peak performance and identify potential problems early.",
    services: [
      "Complete system pressure testing",
      "Zone-by-zone pressure analysis",
      "Leak detection through pressure monitoring",
      "Water flow rate measurement",
      "System efficiency evaluation",
      "Comprehensive inspection reports",
      "Pressure regulator testing and adjustment"
    ],
    signs: [
      "Inconsistent spray patterns across zones",
      "Some heads barely spraying while others gush",
      "System seems to run longer but lawn looks worse",
      "Water hammer or pipe noises when system runs",
      "Heads not fully popping up",
      "Misting instead of proper spray patterns"
    ],
    faqs: [
      {
        question: "Why is pressure testing important for my irrigation system?",
        answer: "Pressure testing reveals hidden leaks, identifies zones with inadequate pressure, and ensures your system delivers the right amount of water. Improper pressure wastes water and damages your landscape."
      },
      {
        question: "How often should I have my system inspected?",
        answer: "We recommend annual inspections, ideally in spring before peak watering season. This catches problems early and ensures efficient operation all season."
      },
      {
        question: "What PSI should my irrigation system run at?",
        answer: "Most residential systems operate best between 40-65 PSI at the head. We'll test your system and recommend adjustments if pressure is too high or low."
      },
      {
        question: "Can high water pressure damage my sprinkler system?",
        answer: "Yes, pressure over 80 PSI can cause premature wear on valves, fittings, and heads. We can install pressure regulators to protect your system and reduce water waste."
      }
    ],
    relatedServices: ["sprinkler-repair", "sprinkler-leak-repair", "sprinkler-head-repair"]
  },
  {
    id: "valve-repair",
    title: "Valve Repair",
    shortDescription: "Professional irrigation valve repair and replacement for reliable zone control.",
    heroImage: "/leak-repair.webp",
    h1: "Irrigation Valve Repair & Replacement in North Texas",
    intro: "Faulty valves are one of the most common causes of sprinkler system problems. AAA Irrigation Service provides expert valve diagnosis, repair, and replacement services to restore proper operation to your irrigation system.",
    services: [
      "Solenoid replacement and repair",
      "Diaphragm replacement",
      "Valve body replacement",
      "Valve box installation and repair",
      "Master valve installation",
      "Flow control adjustment",
      "Wiring repair and replacement"
    ],
    signs: [
      "Zone won't turn on or off",
      "Water continues running after cycle ends",
      "Weak water pressure in specific zones",
      "Clicking sounds from valve area",
      "Water seeping around valve box",
      "Multiple zones running simultaneously"
    ],
    faqs: [
      {
        question: "How long do irrigation valves typically last?",
        answer: "Quality irrigation valves typically last 10-15 years, though diaphragms and solenoids may need replacement sooner. Texas heat and water quality can affect lifespan."
      },
      {
        question: "Should I repair or replace my irrigation valve?",
        answer: "If the valve body is in good condition, replacing the diaphragm or solenoid is often cost-effective. We'll assess the condition and recommend the most economical solution."
      },
      {
        question: "What causes valves to fail?",
        answer: "Common causes include debris in the water supply, electrical issues, age-related wear, and damage from lawn equipment or freezing temperatures."
      },
      {
        question: "Can you add new zones to my existing system?",
        answer: "Yes, we can add valves and zones to expand your irrigation coverage. We'll ensure your water supply and controller can support the additional zones."
      }
    ],
    relatedServices: ["sprinkler-repair", "controller-repair", "sprinkler-leak-repair"]
  },
  {
    id: "sprinkler-head-repair",
    title: "Sprinkler Head Repair",
    shortDescription: "Fast sprinkler head replacement and adjustment for optimal coverage and efficiency.",
    heroImage: "/broken-head.webp",
    h1: "Sprinkler Head Repair & Replacement in Plano, Allen & Frisco",
    intro: "Damaged or misaligned sprinkler heads waste water and leave portions of your lawn under or over-watered. AAA Irrigation Service quickly repairs or replaces sprinkler heads to ensure complete, efficient coverage.",
    services: [
      "Pop-up head replacement",
      "Rotor head repair and adjustment",
      "Spray nozzle replacement",
      "Head height adjustment",
      "Arc and radius adjustment",
      "Drip emitter repair",
      "Upgrade to water-efficient heads"
    ],
    signs: [
      "Heads won't pop up or stay up",
      "Uneven or patchy spray pattern",
      "Heads spraying in wrong direction",
      "Broken or cracked head bodies",
      "Geysers or flooding from head locations",
      "Heads damaged by mowing or traffic"
    ],
    faqs: [
      {
        question: "How often should sprinkler heads be replaced?",
        answer: "Spray heads typically last 3-5 years, while rotor heads can last 7-10 years. We recommend annual inspections to catch worn heads before they fail completely."
      },
      {
        question: "Can you match my existing sprinkler heads?",
        answer: "Yes, we stock all major brands and can match your existing heads for consistent performance. We can also recommend upgrades for better efficiency."
      },
      {
        question: "Why do my sprinkler heads keep getting damaged?",
        answer: "Common causes include mower damage (heads set too high), vehicle traffic, and age. We can adjust head heights and recommend protective measures."
      },
      {
        question: "What's the difference between spray heads and rotors?",
        answer: "Spray heads provide a fixed fan pattern for smaller areas, while rotors shoot a single stream that rotates to cover larger areas. Each has optimal applications."
      }
    ],
    relatedServices: ["sprinkler-repair", "sprinkler-leak-repair", "valve-repair"]
  },
  {
    id: "controller-repair",
    title: "Controller & WiFi Timer Repair",
    shortDescription: "Expert irrigation controller troubleshooting, repair, and smart WiFi upgrades.",
    heroImage: "/controller-repair.webp",
    h1: "Irrigation Controller Repair & WiFi Timer Installation in North Texas",
    intro: "Your irrigation controller is the brain of your sprinkler system. AAA Irrigation Service provides expert troubleshooting, repair, and upgrades for all controller types, including modern WiFi smart controllers that save water and money.",
    services: [
      "Controller diagnostics and troubleshooting",
      "Programming and schedule optimization",
      "Transformer and power supply repair",
      "Zone wiring repair",
      "WiFi controller installation and setup",
      "Rain sensor installation and integration",
      "Smart home integration (Alexa, Google Home)"
    ],
    signs: [
      "Display is blank or showing errors",
      "Zones not responding to programming",
      "Controller not advancing through cycles",
      "Erratic operation or random watering",
      "Unable to connect to WiFi",
      "High water bills despite normal settings"
    ],
    faqs: [
      {
        question: "Should I upgrade to a WiFi sprinkler controller?",
        answer: "WiFi controllers offer significant benefits: remote access, weather-based adjustments, and water usage tracking. Most homeowners see 20-30% water savings, paying for the upgrade within a year."
      },
      {
        question: "What WiFi controllers do you recommend?",
        answer: "We install and service Rachio, Hunter Hydrawise, Rain Bird, and other top brands. We'll recommend the best option based on your system size and features needed."
      },
      {
        question: "Why won't my controller turn on zones?",
        answer: "Common causes include blown fuses, damaged wiring, failed solenoids, or programming issues. Our technicians systematically diagnose and fix the root cause."
      },
      {
        question: "Can you help me program my irrigation controller?",
        answer: "Absolutely. We'll program optimal schedules based on your landscape, local watering restrictions, and seasonal needs. We also provide instruction so you can make adjustments."
      }
    ],
    relatedServices: ["valve-repair", "sprinkler-repair", "commercial-irrigation"]
  },
  {
    id: "commercial-irrigation",
    title: "Commercial Irrigation Maintenance",
    shortDescription: "Comprehensive irrigation maintenance programs for businesses and commercial properties.",
    heroImage: "/commercial-repair.webp",
    h1: "Commercial Irrigation Maintenance in Plano, Allen & North Texas",
    intro: "Keep your commercial property looking professional while minimizing water costs. AAA Irrigation Service provides comprehensive maintenance programs tailored to businesses, office parks, retail centers, and industrial properties throughout North Texas.",
    services: [
      "Monthly and quarterly maintenance programs",
      "Complete system inspections",
      "Seasonal adjustments and programming",
      "Head and nozzle maintenance",
      "Valve and controller service",
      "Water audits and efficiency optimization",
      "24/7 emergency repair service"
    ],
    signs: [
      "Inconsistent landscape appearance",
      "Rising water costs",
      "Tenant or customer complaints",
      "Visible system problems",
      "No current maintenance provider",
      "Need for reliable, scheduled service"
    ],
    faqs: [
      {
        question: "What does commercial irrigation maintenance include?",
        answer: "Our programs include regular inspections, head cleaning and adjustment, controller programming updates, seasonal system checks, minor repairs, and detailed reports. Custom programs available based on your needs."
      },
      {
        question: "How much can I save with professional maintenance?",
        answer: "Properly maintained systems typically use 15-30% less water than neglected ones. Combined with prevented major repairs, most commercial clients see significant ROI from maintenance programs."
      },
      {
        question: "Do you offer emergency service for commercial clients?",
        answer: "Yes, maintenance program clients receive priority emergency response. We understand that irrigation problems can impact your business and act quickly to resolve issues."
      },
      {
        question: "Can you service large commercial properties?",
        answer: "Absolutely. We service properties of all sizes, from small retail locations to large corporate campuses and industrial facilities. Our team has the equipment and expertise for any scale."
      }
    ],
    relatedServices: ["hoa-irrigation", "sprinkler-repair", "controller-repair"]
  },
  {
    id: "hoa-irrigation",
    title: "HOA Irrigation Maintenance",
    shortDescription: "Specialized irrigation services for homeowner associations and community common areas.",
    heroImage: "/sprinkler-system.webp",
    h1: "HOA Irrigation Maintenance Services in Collin County, TX",
    intro: "Maintaining beautiful common areas while managing HOA budgets requires expertise. AAA Irrigation Service partners with homeowner associations throughout Collin County to provide reliable, cost-effective irrigation maintenance for community landscapes.",
    services: [
      "Customized HOA maintenance programs",
      "Common area irrigation management",
      "Entrance and amenity area service",
      "Water usage monitoring and reporting",
      "Budget-friendly repair solutions",
      "Board meeting attendance and reporting",
      "Multi-property management coordination"
    ],
    signs: [
      "Common areas looking stressed or patchy",
      "Water bills exceeding budget",
      "Homeowner complaints about landscape",
      "Current provider unreliable",
      "Need for professional reporting",
      "Seeking competitive bids"
    ],
    faqs: [
      {
        question: "How do you work with HOA boards?",
        answer: "We provide detailed proposals, regular maintenance reports, and can attend board meetings as needed. Our transparent communication keeps boards informed and confident in their irrigation management."
      },
      {
        question: "Can you help reduce our HOA's water costs?",
        answer: "Yes, we specialize in water efficiency. Through system audits, smart controller upgrades, and optimized scheduling, we've helped HOAs reduce water usage by 20-40% while improving landscape appearance."
      },
      {
        question: "Do you handle multiple properties for HOAs?",
        answer: "Absolutely. We manage irrigation for HOAs with single common areas to communities with dozens of maintained zones. Consolidated billing and reporting simplify management."
      },
      {
        question: "What areas do you service for HOAs?",
        answer: "We serve HOAs throughout Collin County including Plano, Allen, Frisco, McKinney, Richardson, and surrounding communities. Contact us for a customized proposal."
      }
    ],
    relatedServices: ["commercial-irrigation", "sprinkler-repair", "controller-repair"]
  },
  {
    id: "emergency-repair",
    title: "Emergency Sprinkler Repair",
    shortDescription: "After-hours emergency irrigation repair when you can't wait until morning.",
    heroImage: "/broken-head.webp",
    h1: "Emergency Sprinkler Repair - After Hours Service in North Texas",
    intro: "Sprinkler emergencies don't wait for business hours. When a major leak, broken main line, or system failure threatens your property, AAA Irrigation Service provides prompt after-hours emergency repair throughout Plano, Allen, and surrounding areas.",
    services: [
      "After-hours emergency response",
      "Main line break repair",
      "Major leak containment and repair",
      "Flooding prevention",
      "Valve emergency shutoff",
      "Controller failure response",
      "Foundation protection services"
    ],
    signs: [
      "Water gushing from broken pipe",
      "Flooding in yard or near foundation",
      "System won't shut off",
      "Major leak discovered after hours",
      "Water entering building or garage",
      "Significant water waste occurring"
    ],
    faqs: [
      {
        question: "What qualifies as a sprinkler emergency?",
        answer: "Emergencies include major leaks wasting significant water, broken main lines, flooding threatening property, systems that won't shut off, and any situation causing immediate property damage."
      },
      {
        question: "How quickly can you respond to emergencies?",
        answer: "We prioritize emergencies and typically respond within 1-2 hours during after-hours periods. Response time may vary based on current demand and your location."
      },
      {
        question: "Is there an extra charge for emergency service?",
        answer: "After-hours emergency calls do carry a service premium to cover the urgent response. However, this cost is minimal compared to water damage or waste from waiting until regular hours."
      },
      {
        question: "Can I shut off my sprinkler system myself?",
        answer: "Yes, if possible, locate your main irrigation shutoff valve (usually near the backflow device) and turn it off. If you can't find it, shut off water at the meter. Call us and we'll handle the rest."
      }
    ],
    relatedServices: ["sprinkler-repair", "sprinkler-leak-repair", "valve-repair"]
  },
  {
    id: "backflow-preventer-installation",
    title: "Backflow Preventer Installation",
    shortDescription: "Licensed backflow preventer installation for residential and commercial irrigation systems in Plano, Allen, and surrounding areas.",
    heroImage: "/backflow-rpz.webp",
    h1: "Backflow Preventer Installation in Plano & Allen, TX",
    intro: "Protecting your home's drinking water starts with a properly installed backflow preventer. AAA Irrigation Service installs backflow prevention devices for residential and commercial irrigation systems throughout Collin County. Our TCEQ licensed technicians (LI0016993) ensure your installation meets all local code requirements. We also coordinate with a certified third-party tester to handle your annual inspection — so you get one point of contact for the entire process.",
    services: [
      "Pressure vacuum breaker (PVB) installation",
      "Reduced pressure zone (RPZ) assembly installation",
      "Double check valve assembly installation",
      "Backflow device replacement and upgrades",
      "Coordination with TCEQ-certified third-party backflow testers",
      "Permit coordination with local municipalities",
      "Post-installation system pressure testing"
    ],
    signs: [
      "No backflow preventer currently installed on your irrigation system",
      "Existing backflow device is cracked, corroded, or leaking",
      "Failed annual backflow inspection",
      "Water district notice requiring backflow device upgrade",
      "Newly installed irrigation system needing code compliance",
      "Visible rust or mineral buildup on existing device"
    ],
    faqs: [
      {
        question: "Do I need a backflow preventer for my sprinkler system in Texas?",
        answer: "Yes. Texas law requires a backflow prevention device on all irrigation systems connected to a potable water supply. Most cities in Collin County — including Plano, Allen, Frisco, and McKinney — enforce this and require annual testing by a licensed tester."
      },
      {
        question: "Does AAA Irrigation perform backflow testing?",
        answer: "We install and replace backflow prevention devices. Annual testing must be performed by a TCEQ-licensed backflow tester — we coordinate with a certified third-party tester on your behalf so you don't have to track down someone separately."
      },
      {
        question: "How much does backflow preventer installation cost?",
        answer: "Installation cost depends on the device type and your system configuration. Pressure vacuum breakers (PVB) are the most common for residential systems and are the most affordable. RPZ assemblies are required for higher-hazard applications. We provide a free estimate before any work begins."
      },
      {
        question: "How long does installation take?",
        answer: "Most residential backflow preventer installations take 1–2 hours."
      },
      {
        question: "What if my city requires a permit?",
        answer: "Some municipalities require a permit for backflow device installation. We handle permit coordination as part of the installation process."
      }
    ],
    relatedServices: ["sprinkler-winterization", "sprinkler-repair", "valve-repair"]
  },
  {
    id: "sprinkler-winterization",
    title: "Sprinkler Winterization & Freeze Protection",
    metaTitle: "Sprinkler Winterization & Freeze Protection | Allen, Plano, Frisco TX",
    metaDescription: "TCEQ Licensed sprinkler winterization & freeze protection in Allen, Plano, Frisco & McKinney TX. Backflow insulation, main valve shutoff, controller & freeze sensor checks. Starting at $95. Call (469) 751-3567.",
    shortDescription: "Seasonal sprinkler winterization, backflow preventer freeze protection, main valve shutoff, and rain/freeze sensor checks across North Texas.",
    heroImage: "/backflow-rpz.webp",
    h1: "Sprinkler Winterization & Freeze Protection in Allen, Plano & Frisco, TX",
    intro: "North Texas hard freezes can crack brass backflow preventers, split above-ground PVC risers, and ruin solenoid valves overnight. AAA Irrigation Service provides complete sprinkler winterization and freeze protection throughout Allen, Plano, Frisco, McKinney, Richardson, Wylie, Murphy, Lucas, and Fairview. Our TCEQ licensed technicians (LI0016993) shut down and protect your irrigation system before freezing weather hits—starting with our $95 seasonal inspection and checkup ($125 in Frisco), with any needed freeze blankets, sensor replacements, or repairs quoted upfront before work begins.",
    services: [
      "Shutting the main irrigation isolation valve and relieving trapped mainline pressure",
      "Draining the backflow preventer (PVB, RPZ, or double-check) and setting test cocks for freeze protection",
      "Installing or inspecting insulated backflow pouches, freeze blankets, and pipe wrap on exposed risers",
      "Setting the irrigation controller to Off, Rain Mode, or winter seasonal-adjust while preserving saved zone schedules",
      "Testing wired and wireless rain/freeze sensors and replacing backup batteries",
      "Inspecting valve boxes for weeping valves or slow leaks that create ice hazards on sidewalks and driveways",
      "Commercial and HOA multi-controller winterization and freeze-watch preparation"
    ],
    signs: [
      "Overnight temperatures in Collin County are forecast to drop below 32°F",
      "Above-ground brass backflow preventer (PVB or RPZ) is uninsulated or has a torn cover",
      "Rain/freeze sensor is unresponsive, disconnected, or has a dead battery",
      "Controller is still running summer or fall watering schedules into November and December",
      "Water is pooling around the backflow assembly, master valve, or street curb when the system is off",
      "Previous winter freeze cracked a bell housing, bonnet, or PVC riser on your property"
    ],
    faqs: [
      {
        question: "How much does sprinkler winterization cost in Allen, Plano, and Frisco?",
        answer: "Our complete system inspection and winterization checkup starts at $95 for Allen, Plano, McKinney, Richardson, Wylie, Murphy, Lucas, and Fairview ($125 in the Frisco extended service area). If your system needs a new insulated backflow pouch, wireless rain/freeze sensor, or valve repair, we provide an upfront quote for your digital signature before any extra work begins."
      },
      {
        question: "What do you do during a North Texas sprinkler winterization service?",
        answer: "We locate and shut the main irrigation isolation valve (where accessible), relieve pressure in the upper assembly, drain and winterize the backflow preventer, inspect or install backflow insulation, test your rain/freeze sensor, check for weeping valves, and set your controller to Off or winter rain mode without erasing your programmed spring schedules."
      },
      {
        question: "When should I winterize my sprinkler system in Allen or Frisco, TX?",
        answer: "In North Texas, the first freeze typically arrives between mid-November and early December, with the hardest freezes hitting in January and February. We recommend winterizing your sprinkler system in October or November before the first sudden cold front."
      },
      {
        question: "Are working rain and freeze sensors required in Collin County cities?",
        answer: "Yes. Cities across Collin County—including Allen, Plano, Frisco, and McKinney—require operational rain and freeze shutoff sensors on automatic irrigation systems to prevent hazardous street icing during winter freezes."
      }
    ],
    relatedServices: ["backflow-preventer-installation", "controller-repair", "sprinkler-repair"]
  }
];

export const getServiceById = (id) => SERVICES.find(service => service.id === id);

export const getRelatedServices = (serviceId) => {
  const service = getServiceById(serviceId);
  if (!service) return [];
  return service.relatedServices.map(id => getServiceById(id)).filter(Boolean);
};
